
export const MRSN_standard = {
    "1":{
        "NUM_DOSES": 8,
        "DILUTION": 3,
        "NUM_DAYS": 5,
        "POSCONS": "",
        "NEGCONS": "",
        "cell_collection": "One PRISM cell line collection was used in the assay: PR500 (including only adherent cell lines).",
        "experimental_control": "Benchmark test agents were also tested at dose to ensure high data quality. All test agents were run in triplicate, and each plate contained positive and negative controls."
    }
}

export const APS_standard = {
    "aps1":{
        "NUM_DOSES": 8,
        "DILUTION": 3,
        "NUM_DAYS": 5,
        "POSCONS": "",
        "NEGCONS": "",
        "cell_collection": "One PRISM cell line collection was used in the assay: PR500 (including only adherent cell lines).",
        "experimental_control": "Benchmark test agents were also tested at dose to ensure high data quality. All test agents were run in triplicate, and each plate contained positive and negative controls."
    },
    "aps2":{
        "NUM_DOSES": 8,
        "DILUTION": 3,
        "NUM_DAYS": 5,
        "POSCONS": "",
        "NEGCONS": "",
        "cell_collection": "Two PRISM cell line collections were used in the assay: PR500 (including only adherent cell lines), and PR300+ (including adherent and suspension cell lines).",
        "experimental_control": "Benchmark test agents were also tested at dose to ensure high data quality. All test agents were run in triplicate, and each plate contained positive and negative controls."
    },
};


export const MTS_standard = {
    "1": {
        "NUM_DOSES": 8,
        "DILUTION": 3,
        "NUM_DAYS": 5,
        "POSCONS": "Bortezomib, 20uM",
        "NEGCONS": "DMSO",
        "cell_collection":"Two PRISM cell line collections were used in the assay: PR500 (including only adherent cell lines), and PR300+ (including adherent and suspension cell lines).",
        "experimental_control": "Benchmark compounds – included in the Validation Compounds – were also tested at dose to ensure high data quality. All compounds were run in triplicate, and each plate contained positive (Bortezomib, 20uM) and negative (DMSO) controls."
    }
}
export const ANT_standard = MTS_standard;
export const PSEL_standard = MTS_standard;

export const EXT_standard = {
    "ext1": {
        "NUM_DOSES": 5,
        "NUM_DAYS": 10,
        "POSCONS": "decitabine",
        "NEGCONS": "DMSO",
        "cell_collection":"One PRISM cell line collection was used in the assay: PR500 (including only adherent cell lines).",
        "experimental_control": "All compounds, including a validation compound (Decitabine), were run in triplicate. Each assay plate contained wells with the negative control (DMSO)."
    }
}

export const EPS_standard = {
    "ext1": {
        "NUM_DOSES": 5,
        "NUM_DAYS": 10,
        "POSCONS": "decitabine",
        "NEGCONS": "DMSO",
        "cell_collection":"One PRISM cell line collection was used in the assay: PR500 (including only adherent cell lines).",
        "experimental_control": "All compounds, including a validation compound (Decitabine), were run in triplicate. Each assay plate contained wells with the negative control (DMSO)."
    },
    "9" :{ // this is for ULA 
        "NUM_DOSES": 8,
        "NUM_DAYS": 5,
        "POSCONS": "Bortezomib",
        "NEGCONS": "DMSO",
        "cell_collection":"One PRISM cell line collection was used in the assay: PR500 (including only adherent cell lines). Benchmark compounds – included in the Validation Compounds – were also tested at dose to ensure high data quality.",
        "experimental_control": "All compounds were run in triplicate, and each plate contained positive (Bortezomib, 20uM) and negative (DMSO) controls."
    },
    "11" :{ // this is for ULA
        "NUM_DOSES": 8,
        "NUM_DAYS": 7,
        "POSCONS": "Bortezomib",
        "NEGCONS": "DMSO",
        "cell_collection":"One PRISM cell line collection was used in the assay: PR500 (including only adherent cell lines). Benchmark compounds – included in the Validation Compounds – were also tested at dose to ensure high data quality.",
        "experimental_control": "All compounds were run in triplicate, and each plate contained positive (Bortezomib, 20uM) and negative (DMSO) controls."
    },
    "14": {
        "NUM_DOSES": 8,
        "NUM_DAYS": 7,
        "POSCONS": "Bortezomib",
        "NEGCONS": "DMSO",
        "cell_collection":"One PRISM cell line collection was used in the assay: PR500 (including only adherent cell lines).",
        "experimental_control": "All compounds were run at least in triplicate. Benchmark compounds – included in the Validation Compounds – were also tested to ensure high data quality. Each plate contained positive (Bortezomib, 20uM) and negative (DMSO) controls."
    },
    "eps4": {
        "NUM_DOSES": 5,
        "NUM_DAYS": 10,
        "POSCONS": "KSQ-4279",
        "NEGCONS": "DMSO",
        "cell_collection":"One PRISM cell line collection was used in the assay: PR500 (including only adherent cell lines).",
        "experimental_control": "All compounds, including a validation compound (KSQ-4279), were run in six replicates. Each assay plate contained wells with the negative control (DMSO)."
    }
}




export const CPS_standard = {
    "1": {
        "NUM_DOSES": 7,
        "DILUTION": 3,
        "NUM_DAYS": 5,
        "POSCONS": "Bortezomib, 20uM",
        "NEGCONS": "DMSO",
        "cell_collection":"Two PRISM cell line collections were used in the assay: PR500 (including only adherent cell lines), and PR300+ (including adherent and suspension cell lines).",
        "experimental_control": "Benchmark compounds – included in the Validation Compounds – were also tested at dose to ensure high data quality. All compounds were run in triplicate, and each plate contained positive (Bortezomib, 20uM) and negative (DMSO) controls."
    }
};



export function DepMapVersionString(screen) {
    var screenNumber = parseInt(screen.match(/\d+/)[0], 10);
    if (screen.startsWith("MTS") && screenNumber >= 23 ) {
        return "(DepMap 23Q2)"
    } else if (screen.startsWith("CPS009") && screenNumber >= 9 ) {
        return
    } else {
        return ""
    }
}


